import { Trans } from '@lingui/react/macro';
import { Tag } from '@remarkable/ark-web';
import React, { type MouseEvent, type PropsWithChildren } from 'react';
import { Tooltip } from 'src/components';
import { LinkExternal } from 'src/components/LinkExternal';
import { SUPPORT_URL } from 'src/utils/urls/supportUrls';

export const ConvertToNotebookTooltip: React.FC<
  PropsWithChildren<{ componentLocation: string }>
> = ({ children, componentLocation }) => {
  return (
    <Tooltip
      side="bottom"
      title={
        <div className="flex flex-row items-start gap-8">
          <p className="max-w-[200px]">
            <Trans>
              Turn Word files into editable notebooks.{' '}
              <LinkExternal
                to={SUPPORT_URL.ARTICLES.CONVERT_TO_NOTEBOOK}
                inline
                onClick={(e: MouseEvent) => e.stopPropagation()}
                componentLocation={componentLocation}
              >
                Learn more
              </LinkExternal>
            </Trans>
          </p>
          <Tag
            variant="themed-outlined"
            dataTheme="dark-neutral"
            bgColorIntensity={5}
          >
            <Trans>BETA</Trans>
          </Tag>
        </div>
      }
    >
      {children}
    </Tooltip>
  );
};
